import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ServiceType, ServiceTypeEntity} from "../../../model/service-type";
import {contains} from "../../../util/util";
import {ServiceTypeFacet, ServiceTypeFacetEntity} from "../../../model/service/service-type-facet";
import {ServiceTypeMode, ServiceTypeModeEntity} from "../../../model/service/service-type-mode";
import {ServiceTypeFacetMode, ServiceTypeFacetModeEntity} from "../../../model/service/service-type-facet-mode";

export interface ServiceTypeSelectorProps {
  regionId?: string
  showDoNotUse?: boolean;
}

const getRegionIdParam = createParamSelector<ServiceTypeSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getShowDoNotUseParam = createParamSelector<ServiceTypeSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse)

export const serviceTypesSelector = () => createSelector(
  [getUseQueryResultData<ServiceType[]>, getRegionIdParam, getShowDoNotUseParam],
  (data, regionId, showDoNotUse) => {
    return selectServiceTypesAndTransform(
      data ?? [], {
        regionId: regionId,
        showDoNotUse: showDoNotUse,
      }
    );
  }
);

export const serviceTypeSelector = () => createSelector(
  [getUseQueryResultData<ServiceType>],
  (data) => {
    return data ? transformServiceType(data) : undefined;
  }
);

export const selectServiceTypes = (values?: ServiceType[], selector?: ServiceTypeSelectorProps): ServiceType[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (!contains(v.regionList, id => id === selector.regionId)) {
        filterIn = false;
      }
    }

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const transformServiceType = (value: ServiceType): ServiceTypeEntity => {
  return ServiceTypeEntity.from(value)
}

export const selectServiceTypesAndTransform = (values?: ServiceType[], selector?: ServiceTypeSelectorProps): ServiceTypeEntity[] => {
  const selected = selectServiceTypes(values, selector);
  return selected.map(transformServiceType);
};

export interface ServiceTypeFacetSelectorProps {

}

export const serviceTypeFacetsSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFacet[]>, getRegionIdParam, getShowDoNotUseParam],
  (data, regionId, showDoNotUse) => {
    return selectServiceTypeFacetsAndTransform(
      data ?? [], {
        regionId: regionId,
        showDoNotUse: showDoNotUse,
      }
    );
  }
);

export const serviceTypeFacetSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFacet>],
  (data) => {
    return data ? transformServiceTypeFacet(data) : undefined;
  }
);

export const selectServiceTypeFacets = (values?: ServiceTypeFacet[], selector?: ServiceTypeFacetSelectorProps): ServiceTypeFacet[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformServiceTypeFacet = (value: ServiceTypeFacet): ServiceTypeFacetEntity => {
  return ServiceTypeFacetEntity.from(value)
}

export const selectServiceTypeFacetsAndTransform = (values?: ServiceTypeFacet[], selector?: ServiceTypeFacetSelectorProps): ServiceTypeFacetEntity[] => {
  const selected = selectServiceTypeFacets(values, selector);
  return selected.map(transformServiceTypeFacet);
};

export interface ServiceTypeModeSelectorProps {

}

export const serviceTypeModesSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeMode[]>, getRegionIdParam, getShowDoNotUseParam],
  (data, regionId, showDoNotUse) => {
    return selectServiceTypeModesAndTransform(
      data ?? [], {
        regionId: regionId,
        showDoNotUse: showDoNotUse,
      }
    );
  }
);

export const serviceTypeModeSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeMode>],
  (data) => {
    return data ? transformServiceTypeMode(data) : undefined;
  }
);

export const selectServiceTypeModes = (values?: ServiceTypeMode[], selector?: ServiceTypeModeSelectorProps): ServiceTypeMode[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformServiceTypeMode = (value: ServiceTypeMode): ServiceTypeModeEntity => {
  return ServiceTypeModeEntity.from(value)
}

export const selectServiceTypeModesAndTransform = (values?: ServiceTypeMode[], selector?: ServiceTypeModeSelectorProps): ServiceTypeModeEntity[] => {
  const selected = selectServiceTypeModes(values, selector);
  return selected.map(transformServiceTypeMode);
};

export interface ServiceTypeFacetModeSelectorProps {

}

export const serviceTypeFacetModesSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFacetMode[]>, getRegionIdParam, getShowDoNotUseParam],
  (data, regionId, showDoNotUse) => {
    return selectServiceTypeFacetModesAndTransform(
      data ?? [], {
        regionId: regionId,
        showDoNotUse: showDoNotUse,
      }
    );
  }
);

export const serviceTypeFacetModeSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFacetMode>],
  (data) => {
    return data ? transformServiceTypeFacetMode(data) : undefined;
  }
);

export const selectServiceTypeFacetModes = (values?: ServiceTypeFacetMode[], selector?: ServiceTypeFacetModeSelectorProps): ServiceTypeFacetMode[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformServiceTypeFacetMode = (value: ServiceTypeFacetMode): ServiceTypeFacetModeEntity => {
  return ServiceTypeFacetModeEntity.from(value)
}

export const selectServiceTypeFacetModesAndTransform = (values?: ServiceTypeFacetMode[], selector?: ServiceTypeFacetModeSelectorProps): ServiceTypeFacetModeEntity[] => {
  const selected = selectServiceTypeFacetModes(values, selector);
  return selected.map(transformServiceTypeFacetMode);
};
